import mweixin from '../report/report_base.js';
import * as base from '../base/mbase.js';
import * as Str from '../base/string.js';
import * as localstorage from '../base/localstorage.js';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import Dom from '../base/mdom.js';
import env from '../common/env';
var getQueryStr = base.getQueryStr;
var getKeyValue = localstorage.getKeyValue;

let exportData;
var _top = Dom.window;
var openid = getQueryStr('openid', null, _top) || getKeyValue('openid') || '';
var nilReport = [];
var isQbWebview = env.isiOS && env.isWepkg(); // ios下离线包是使用qbwebview

/*
 *  ---->>>>  仅支持 带 openid 批量上报 <<<---------
 *  ----》》》 如果取不到openid,则不会上报 《《《------
 *
 * PB: cgi/mmocgamecomm/mmocgamecomm.proto#551
 *
 * Example:
 *     import batchReport from 'report/10861_batch.js';
 *     batchReport({
 *             iActID: 12,
 *             nNoticeID: 100023432,
 *             iPid: 1,
 *             iPos: 1,
 *             nUrOpState: 2,
 *             sAppID: 'wx62d9035fd4fd2059',
 *             nSourceScene: 1,
 *             iOptype: 1,
 *             iGiftID: 1,
 *             nDestinationScene: 1,
 *             openid: 'xxxx',
 *             ExternInfo: '{"a":1,"b":2}'
 *     });
 */

function sendBeacon(url, data, options) {
    var formattedData = data,
        contentType = 'text/plain';
    if (typeof data === 'string') {
        contentType = 'application/x-www-form-urlencoded';
    } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
        contentType = data.type;
    } else if (data && typeof data === 'object') {
        contentType = 'application/json';
        formattedData = JSON.stringify(data);
    }
    if (options.enableSendBeacon && 'sendBeacon' in navigator) {
        if (data && typeof data !== 'string' && (typeof Blob === 'undefined' || data instanceof Blob === false)) {
            /* SHOULD NOT set Blob type to 'application/json', or error occurred:
            Failed to execute 'sendBeacon' on 'Navigator': sendBeacon() 
            with a Blob whose type is not any of the CORS-safelisted 
            values for the Content-Type request header is disabled 
            temporarily. See http://crbug.com/490015 for details.
            sendBeacon is follow CORS, but doesn't satisfy CORS spec.
            According to https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests,
            avaliable type values for a "simple request":
                - application/x-www-form-urlencoded
                - multipart/form-data
                - text/plain
            */

            // formattedData = new Blob([JSON.stringify(data)], {type: 'application/json'});
            formattedData = new Blob([JSON.stringify(data)], { type: 'application/x-www-form-urlencoded' });
        }
        return navigator.sendBeacon(url, formattedData);
    } else if (options.enableFetch && 'fetch' in window) {
        /*
        var isSameOrigin = true,
            originMatches;
        originMatches = url.match(/^(https?:)?\/\/([^/]*)/);
        if (originMatches && originMatches.length > 2) {
            var isSameProtocol, isSameHost;
            isSameProtocol = !originMatches[1] || originMatches[1] === location.protocol ? true : false;
            isSameHost = originMatches[2] && originMatches[2] === location.host ? true : false; 
            isSameOrigin = isSameProtocol && isSameHost ? true : false;
        }
        */

        // fallback to fetch
        let post = {
            method: 'POST',
            mode: 'no-cors',
            credentials: 'include',
            // https://developer.mozilla.org/en-US/docs/Web/API/Request/cache
            cache: 'no-store',
            // https://fetch.spec.whatwg.org/#requests
            // This can be used to allow the request to outlive the environment settings object,
            //  e.g., navigator.sendBeacon and the HTML img element set this flag.
            // Requests with this flag set are subject to additional processing requirements.
            keepalive: true,
            headers: {
                'Content-Type': contentType,
            },
            body: formattedData,
        };
        return fetch(url, post);
    } else {
        // fallback to XHR
        var xhr;
        xhr = typeof XMLHttpRequest !== 'undefined' ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('POST', url, 'async' in options ? options.async : true);
        xhr.withCredentials = true;
        if (typeof Blob !== 'undefined' && data instanceof Blob) {
            data.type && xhr.setRequestHeader('Content-Type', data.type);
        } else {
            xhr.setRequestHeader('Content-Type', contentType + '; charset=utf-8');
        }
        try {
            xhr.send(formattedData);
        } catch (error) {
            return false;
        }
        return true;
    }
}

_top.addEventListener(
    'unload',
    function () {
        if (nilReport.length > 0 && openid) {
            var url = [
                'https://game.weixin.qq.com',
                '/cgi-bin/comm/actreport?openid=',
                openid,
                '&QB&t=',
                Date.now(),
            ].join('');
            var data = 'BatchData=' + encodeURIComponent(JSON.stringify(nilReport));
            sendBeacon(url, data, {
                enableSendBeacon: true,
                async: true,
                enableFetch: true,
            });
        }
    },
    false
);

(function (_aoExport, win, doc) {
    'use strict';
    // 上报类型中的device必须是字符串，
    // iphone,android-lite-,android,symbian60v3,symbian60v5,
    // wp7,webwx,blackberry-,wp8,s40asha v5,s40asha,BlackBerry10-,其他字符串

    var _reportObj = _aoExport.reportObj;
    var DELAY_TIME = 3000;
    var DELAY_COUNT = 10;
    var DELAY_TICK = Date.now() + DELAY_TIME;
    var DELAY_HLD = null;

    //活动类上报
    var baseReport = function (_o) {
        var _sUrl = {};
        _o = _o || {};

        //abt不能为0，千万不要用它作默认值。
        var abt = parseInt(_o.abt || getQueryStr('abt', null, _top)) || -1;
        var actid = _o.iActID || _reportObj.actid || 0;
        var rpt_allpath = getQueryStr('rpt_allpath');
        _sUrl.noticeid = _o.nNoticeID || _reportObj.noticeid || 0;
        _sUrl.appid = '' + (_o.sAppID || win.sAppID || win.sAppId || '');
        _sUrl.usropstate = +(_o.nUrOpState || 0);
        _sUrl.actid = +actid;
        _sUrl.networktype = '' + (_o.nNetworkType || _reportObj.networktype || '');
        _sUrl.sourcescene = +(_o.nSourceScene || _reportObj.sourcescene || getQueryStr('ssid', null, _top) || 0);
        _sUrl.destinationscene = +(_o.nDestinationScene || 0);
        _sUrl.appstate = +(_o.nAppState || 0);
        _sUrl.appversion = '' + (_o.nAppVersion || '');
        _sUrl.assiststate = +(_o.nAssistState || '');
        _sUrl.assistversion = '' + (_o.nAssistVersion || 0);
        _sUrl.optype = +(_o.iOptype || 0);
        _sUrl.giftid = +(_o.iGiftID || 0);
        _sUrl.pid = +(_o.iPid || 0);
        _sUrl.pos = +(_o.iPos || 0);

        if (('' + rpt_allpath).length > 0) {
            rpt_allpath += '_act' + actid;
        }
        _sUrl.allpath = _o.sAllPath || rpt_allpath || '';

        // 设置ExterInfo
        _o.ExternInfo = _o.ExternInfo || '{}';

        // 做逻辑，支持10861跳转到活动时，把url里的abt存入extinfo
        var _extinfo = decodeURIComponent(_o.ExternInfo);
        try {
            _extinfo = JSON.parse(_extinfo);
            if (!isNaN(abt)) {
                _extinfo.abt = abt;
            }
            if (_extinfo.openid) {
                openid = _extinfo.openid;
            }
            _o.ExternInfo = encodeURIComponent(JSON.stringify(_extinfo));
        } catch (error) {
            console.error('10861 extinfo json parse error!');
        }
        _sUrl.externinfo = _o.ExternInfo;
        if (_o.openid) {
            openid = _o.openid;
        }
        console.log(_sUrl);
        return _sUrl;
    };

    //只获取登陆态。。。。。
    var getLoginInfo = function (cbk) {
        if (!openid) {
            console.error('openid mode only, thanks');
            return;
        }
        // 仅支持openid上报
        cbk &&
            cbk({
                openid,
                t: new Date().getTime(),
            });
    };

    //10861 活动批量上报
    var batch10861 = function (list, openid) {
        var _report = [];
        for (var i = 0, il = list.length; i < il; i++) {
            var _sUrl = baseReport(list[i]);
            _report.push(Str.mapToStr(_sUrl));
        }
        var reportHandler = function (login) {
            var qryStr = ['/cgi-bin/comm/actreport?', Str.mapToStr(login), '&QB&n=1'].join('');
            var url = ['https://game.weixin.qq.com', qryStr].join('');
            var data = 'BatchData=' + encodeURIComponent(JSON.stringify(_report));
            sendBeacon(url, data, {
                enableSendBeacon: !isQbWebview,
                async: true,
                enableFetch: !isQbWebview,
            });
        };
        if (openid) {
            reportHandler({
                openid,
                t: new Date().getTime(),
            });
        } else {
            getLoginInfo(openid, reportHandler);
        }
        /*
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {};
        for (var i = 0, il = list.length; i < il; i++) {
            var _sUrl = baseReport(list[i]);
            _report.push(Str.mapToStr(_sUrl));
        }
        var method = 'POST';
        getLoginInfo(function(login) {
            //批量BatchData方式
            var qryStr = ['/cgi-bin/comm/actreport?', Str.mapToStr(login), '&QB&'].join('');
            xhr.open(method, qryStr, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.send('BatchData=' + encodeURIComponent(JSON.stringify(_report)));
        });
        */
    };
    // 延时上报
    var delayReport = function (openid) {
        if (nilReport.length < 1) {
            return;
        }
        if (nilReport.length < DELAY_COUNT && Date.now() < DELAY_TICK) {
            clearTimeout(DELAY_HLD);
            DELAY_TICK = Date.now() + DELAY_TIME;
            DELAY_HLD = setTimeout(() => {
                delayReport(openid);
            }, DELAY_TIME);
        } else {
            batch10861(nilReport.splice(0, nilReport.length), openid);
        }
    };
    // 上报入口
    var report = function (param, timeout = DELAY_TIME, count = DELAY_COUNT) {
        let openid;
        if (param instanceof Array) {
            nilReport = nilReport.concat(param);
            if (param[0] && param[0].openid) {
                openid = param[0].openid;
            }
        } else {
            nilReport.push(param);
            if (param && param.openid) {
                openid = param.openid;
            }
        }
        if (!isNaN(timeout)) {
            DELAY_TIME = timeout;
        }
        if (!isNaN(count) && count >= 1) {
            DELAY_COUNT = count;
        }
        clearTimeout(DELAY_HLD);
        DELAY_HLD = setTimeout(() => {
            delayReport(openid);
        }, 1000);
    };

    // 暴露一下上报接口。
    _aoExport.batchActReport = report;
    exportData = report;
})(mweixin, window, document);
export default exportData;
